import i18next from 'i18next';
import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  // adminUser: Yup.string()
  //   .required(i18next.t('validation.required.adminUser'))
  //   .min(2, i18next.t('validation.textTooShort')),
  // adminPass: Yup.string()
  //   .required(i18next.t('validation.required.adminPass'))
  //   .min(8, i18next.t('validation.textTooShort')),
  serverUri: Yup.string().required(i18next.t('validation.required.serverUri')),
});
